import { render, staticRenderFns } from "./FrzEnterEnvironmentQR.vue?vue&type=template&id=67020bde"
import script from "./FrzEnterEnvironmentQR.vue?vue&type=script&lang=js"
export * from "./FrzEnterEnvironmentQR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports